export const BREAKPOINTS = Object.freeze({
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
});

export const DESKTOP_BREAKPOINT = BREAKPOINTS.lg;
export const MOBILE_MAX_WIDTH = BREAKPOINTS.lg - 1;

export const mediaQueryMinWidth = (size) => `(min-width: ${size}px)`;
export const mediaQueryMaxWidth = (size) => `(max-width: ${size}px)`;
